import { InjectionToken } from "@angular/core";

export const GLOBAL_MESSAGE_STATE_PROP = new InjectionToken<string>("GLOBAL_MESSAGE_STATE_PROP");
export const globalMessageStatePropProvider = {
    provide: GLOBAL_MESSAGE_STATE_PROP,
    useValue: "globalMessages",
};

export const FORM_POST_MESSAGE_STATE_PROP = new InjectionToken<string>("FORM_POST_MESSAGE_STATE_PROP");
export const formPostMessageStatePropProvider = {
    provide: FORM_POST_MESSAGE_STATE_PROP,
    useValue: "formPostMessage",
};
